import React, {memo} from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import useInterval from 'hooks/useInterval';
dayjs.extend(relativeTime);
const TimeLabel = memo(({time}: {time: dayjs.ConfigType}) => {
   const [timeToNow, setTime] = React.useState<string>(() => dayjs().to(time));

   useInterval(() => {
      setTime(dayjs().to(time));
   }, 1000);

   return (
      <div
         style={{
            display: 'block',
            float: 'right',
            fontWeight: 300,
            padding: '0 0 0 1rem',
            fontStyle: 'italic',
         }}
      >
         {timeToNow}
      </div>
   );
});

export default TimeLabel;
